import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

/**
 * Main Controller Documentation
This class contains the logic for the main component. It is responsible for 
loading the iframe based on the embedId parameter and setting the token for the iframe.
 */
export class MainController {

/**
 * The constructor is responsible for loading the base modules and 
 * also for setting the baseConfigService.
  */

  /*@ngInject*/
  constructor($http,$scope, $location, baseConfigService, navService) {
    // Load base modules 
    this.$http = $http;
    this.$scope = $scope;
    this.$location = $location;

    $scope.browserCheck = false;

   

    this.baseConfigService = baseConfigService;
    this.navService = navService;
 }

 /**
  * This method is responsible for setting the params from the url and calling the loadIframe method.
  */
 $onInit() {

      // Browser check
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
      if (isSafari || isIOS) {
        // Display message for Safari or iOS
        // alert("This dashboard is best viewed on a desktop with Chrome or Firefox.");
        this.$scope.browserCheck = true;
      } else {
        this.$scope.browserCheck = false;
      }

  this.$scope.params = this.$location.search();
  this.loadIframe(this.$scope.params);
  this.$scope.page = this.navService.getPage();
  console.log("this is the page: ", this.$scope.page);
  this.$scope.embedId = this.$location.search().embedId;
  console.log(this.$scope.embedId);

  /**
   * ! This function checks the ID in the url and then filters this.$scope.allMetadata to 
   * ! get the necessary title and description
   * ! Check url id
   * ! Filter variable allMetadata
   * ! Update on main.html page
   * 
   */

}

/**
 * 
 * This method is responsible for making the http request to get the embed information from the server. 
 * It also sets the title and token for the iframe.
 */
loadIframe(params){
  var adminBaseURL = this.baseConfigService.getAdminBaseURL();
   var embedId = params.embedId;
   var $scope = this.$scope;

   //Get page details for title and description
   this.$scope.pageDetails = this.navService.getDetails(embedId);

 
     //Embed Iframe Function
     this.$http.get(`${adminBaseURL}/embed/tableau/${embedId}`)
        .then(function (response) {
          var embedInfo = response.data;
          console.log(embedInfo);
          $scope.title = embedInfo.name;
          $scope.token = embedInfo.token;
          document.getElementById('tableau-viz').token = embedInfo.token;
          document.getElementById('tableau-viz').src = embedInfo.url;
        
        })
        .catch(function (error) {
          console.log(error);
        })
    // this.$http.get(`${adminBaseURL}/embed/tableau/${embedId}`)
    // .then(function (response) {
    //   var embedInfo = response.data;
    //   console.log(embedInfo);
    //   $scope.title = embedInfo.name;
    //   // document.getElementById('tableau-viz').token = embedInfo.token;
    //   // document.getElementById('tableau-viz').src = embedInfo.url;
    //   // Wait for the iframe to load
    //   document.getElementById('tableau-viz').onload = function () {
    //     // Set the iframe source
    //     document.getElementById('tableau-viz').src = embedInfo.url;

    //     // Send the token to the iframe using postMessage
    //     document.getElementById('tableau-viz').contentWindow.postMessage({
    //       "type": "tableau.embed.setEmbedToken",
    //       "token": embedInfo.token
    //     }, "*");
    //   };

    // })
    // .catch(function (error) {
    //   console.log(error);
    // })

       
 }


}

export default angular.module('epsMobileApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js